module.exports = __webpack_public_path__ + "img/Slice1.ad50a70e.png";